import { Heading, VStack } from 'native-base'

interface PageHeaderProps {
  trackingIdParam?: string
}

/** Page header for the report issue flow, linking back to the tracking page. */
export default function PageHeader({ trackingIdParam }: PageHeaderProps) {
  return (
    <VStack width="100%" display="flex" flexGrow={1} flexDirection="column" alignItems="flex-start" mb={5}>
      <Heading
        fontSize="24px"
        fontWeight="700"
        fontFamily="Matter SemiBold"
        lineHeight="100%"
        letterSpacing="-2%"
        mb={1}
      >
        Report A Delivery Issue
      </Heading>
      {!trackingIdParam && (
        <Heading
          fontSize="14px"
          fontWeight="400"
          fontFamily="Matter Regular"
          lineHeight="125%"
          letterSpacing="-1%"
          mb={2}
        >
          Enter your Tracking ID to get started
        </Heading>
      )}
    </VStack>
  )
}
